<template>
  <div>
    <label
      v-if="label"
      :for="name"
      class="mb-1 block text-xs font-medium text-background-fg/70"
    >
      {{ label }}
    </label>
    <BasePriceInput
      v-model="inputModel"
      :has-error="hasError"
      :currency="currency"
      :placeholder="placeholder"
      :name="name"
      :disabled="disabled"
      :highlight="highlight"
      :min="min"
    />
    <template v-if="hasError">
      <p class="mt-1 text-xs font-medium text-error">
        {{ errorMessage }}
      </p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate"

const props = withDefaults(
  defineProps<{
    name: string
    label?: string
    placeholder?: string
    currency?: string
    disabled?: boolean
    highlight?: boolean
    min?: number
  }>(),
  {
    label: "",
    placeholder: "",
    currency: "GBP",
    disabled: false,
    min: undefined,
  }
)

const {
  value: inputValue,
  errorMessage,
  handleChange,
} = useField<number>(toRef(props, "name"), undefined, {
  syncVModel: false,
})

const inputModel = computed({
  get: () => inputValue.value,
  set: (value: number) => handleChange(value),
})

const hasError = computed(() => !!errorMessage.value)
</script>
